import styled from "styled-components";

export const MyWorksWrapper = styled.div`
    display: grid;
    z-index: 1;
    height: 860px;
    width: 100%;
    max-width: 1100px;
    margin: auto;
    padding: 0 24px;
    justify-content: center;
    column-gap: 10px;
    row-gap: 1em;
    grid-template-columns : 1fr 1fr;
    grid-template-rows: repeat(3, 1fr);
    justify-items: stretch;
    `;

export const CenterContentDiv = styled.div`
    width: fit-content;
    max-width: 1100px;
    margin: auto;
`
